module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Dvd1 SitePage Search */

(function(fox) {
	fox.registerWidget('SitePage_Join', {
		
	}, 'Site_Page');

})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/main/widget/sitepage/join.js
// module id = 134
// module chunks = 4